import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
import { trackMetaEvent } from '../hooks/useMetaPixel';
export function PricingSection() {
  const handleBuyClick = () => {
    // Fire AddToCart event first
    trackMetaEvent('AddToCart', {
      content_name: 'Sistema Keto Criollo',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    // Small delay to let the pixel request complete before navigating
    setTimeout(() => {
      window.open('https://vitalizaya.com/cart/51434359357656:1', '_blank', 'noopener,noreferrer');
    }, 400);
  };
  return <section id="pricing" className="bg-[#0D0D0D] text-white py-20 md:py-32 px-4 relative" data-id="element-97">
      <div className="max-w-4xl mx-auto text-center" data-id="element-98">
        <div className="mb-12" data-id="element-99">
          <p className="font-inter text-xl md:text-2xl text-gray-300 leading-relaxed max-w-2xl mx-auto" data-id="element-100">
            No necesitas gastar 200 mil pesos en una consulta nutricional ni 500
            mil en un mercado "especial". Obtén todo el sistema paso a paso por
            una fracción de eso.
          </p>
        </div>

        <div className="bg-gradient-to-b from-[#1A1A1A] to-[#0D0D0D] border-2 border-[#F5C518] rounded-3xl p-8 md:p-12 max-w-2xl mx-auto shadow-[0_0_50px_rgba(245,197,24,0.15)] relative" data-id="element-101">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-[#F5C518] text-[#1A1A1A] font-montserrat font-bold px-6 py-2 rounded-full text-sm md:text-base uppercase tracking-wider whitespace-nowrap" data-id="element-102">
            Precio Especial de Lanzamiento
          </div>

          <div className="mt-6 mb-8" data-id="element-103">
            <span className="font-inter text-gray-400 text-lg line-through block mb-2" data-id="element-104">
              Valor Normal: 47 USD
            </span>
            <span className="font-inter text-gray-500 text-base line-through block mb-1" data-id="element-105">
              Antes: 17 USD
            </span>
            <div className="flex justify-center items-center gap-3 mb-1" data-id="element-106">
              <div className="flex items-baseline gap-2" data-id="element-107">
                <span className="font-montserrat font-black text-6xl md:text-7xl text-white" data-id="element-108">
                  6.39
                </span>
                <span className="font-montserrat font-bold text-2xl text-[#F5C518]" data-id="element-109">
                  USD
                </span>
              </div>
              <span className="bg-[#22C55E] text-white font-montserrat font-bold text-sm md:text-base px-3 py-1.5 rounded-lg uppercase tracking-wide animate-pulse" data-id="element-110">
                -86% OFF
              </span>
            </div>
            <p className="font-inter text-gray-400 mt-2" data-id="element-111">(Aprox. 26.000 COP)</p>
          </div>

          <CTAButton onClick={handleBuyClick} className="w-full md:w-auto text-sm md:text-lg px-4 md:px-8" data-id="element-112" />

          <div className="mt-8 flex items-center justify-center gap-2 text-gray-400 font-inter text-sm" data-id="element-113">
            <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-114" />
            <span data-id="element-115">Pago 100% seguro</span>
          </div>
        </div>
      </div>
    </section>;
}